export default "__VITE_ASSET__B0cpIjd9__"